import {AdminUserType} from 'Users/models/User/EnrollTrack/AdminUserType';
import {BrokerUserType} from 'Users/models/User/EnrollTrack/BrokerUserType';
import {ClientOnboardingUserType} from 'Users/models/User/EnrollTrack/ClientOnboardingUserType';
import {DirectorUserType} from 'Users/models/User/EnrollTrack/DirectorUserType';
import {EmployerUserType} from 'Users/models/User/EnrollTrack/EmployerUserType';
import {EtsEnrollmentOperationsUserType} from 'Users/models/User/EnrollTrack/EtsEnrollmentOperationsUserType';
import {EtsLeadershipUserType} from 'Users/models/User/EnrollTrack/EtsLeadershipUserType';
import {SalesDistributionUserType} from 'Users/models/User/EnrollTrack/SalesDistributionUserType';
import {SalesSupportUserType} from 'Users/models/User/EnrollTrack/SalesSupportUserType';
import {AgentUserType} from 'Users/models/User/EnrollTrack/AgentUserType';
import {EtsDataOperationsUserType} from 'Users/models/User/EnrollTrack/EtsDataOperationsUserType';
import {FileAnalystUserType} from 'Users/models/User/EnrollTrack/FileAnalystUserType';
import {FileManagementUserType} from 'Users/models/User/EnrollTrack/FileManagementUserType';
import {ManagerUserType} from 'Users/models/User/EnrollTrack/ManagerUserType';
import {HomeOfficeUserType} from 'Users/models/User/EnrollTrack/HomeOfficeUserType';
import {EnrollmentTechnologyPartnerUserType} from 'Users/models/User/EnrollTrack/EnrollmentTechnologyPartnerUserType';

export enum EnrollTrackRole {
  Undetermined,
  FileManagement,
  FileAnalyst,
  Manager,
  Director,
  EnrollmentTechnologyPartner,
  Employer,
  Broker,
  Admin,
  HomeOffice,
  EtsEnrollmentOperations,
  EtsDataOperations,
  ClientOnboarding,
  SalesSupport,
  SalesDistribution,
  EtsLeadership,
  Agent,
  UserSupport,
}

export class UndeterminedEnrollmentTrackingUserType {
  public readonly key = 'UndeterminedEnrollmentTrackingUserType';
  public readonly enrollTrackRole = EnrollTrackRole.Undetermined;
}

export class InvalidEnrollmentTrackingUserType {
  public readonly key = 'InvalidEnrollmentTrackingUserType';
  public readonly value = new UndeterminedEnrollmentTrackingUserType();
}

export class ValidEnrollmentTrackingUserType {
  public readonly key = 'ValidEnrollmentTrackingUserType';

  constructor(
    public readonly value:
      | FileAnalystUserType
      | FileManagementUserType
      | AdminUserType
      | HomeOfficeUserType
      | DirectorUserType
      | ManagerUserType
      | EmployerUserType
      | ClientOnboardingUserType
      | EtsEnrollmentOperationsUserType
      | EnrollmentTechnologyPartnerUserType
      | BrokerUserType
      | EtsDataOperationsUserType
      | EtsLeadershipUserType
      | AgentUserType
      | SalesSupportUserType
      | SalesDistributionUserType
  ) {}
}

export type EnrollmentTrackingUserType = ValidEnrollmentTrackingUserType | InvalidEnrollmentTrackingUserType;

type EnrollTrackUserTypeOptions<TReturn> = {
  Admin: (adminUserType: AdminUserType) => TReturn;
  Broker: (brokerUserType: BrokerUserType) => TReturn;
  ClientOnboarding: (clientOnboardingUserType: ClientOnboardingUserType) => TReturn;
  Director: (directorUserType: DirectorUserType) => TReturn;
  Employer: (employerUserType: EmployerUserType) => TReturn;
  EtsDataOperations: (etsDataOperationsUserType: EtsDataOperationsUserType) => TReturn;
  FileAnalyst: (fileAnalystUserType: FileAnalystUserType) => TReturn;
  FileManagement: (fileManagementUserType: FileManagementUserType) => TReturn;
  Manager: (managerUserType: ManagerUserType) => TReturn;
  EtsEnrollmentOperations: (etsEnrollmentOperations: EtsEnrollmentOperationsUserType) => TReturn;
  HomeOffice: (homeOfficeUserType: HomeOfficeUserType) => TReturn;
  SalesDistribution: (salesDistributionUserType: SalesDistributionUserType) => TReturn;
  SalesSupport: (salesSupportUserType: SalesSupportUserType) => TReturn;
  EnrollmentTechnologyPartner: (enrollmentTechnologyPartnerUserType: EnrollmentTechnologyPartnerUserType) => TReturn;
  EtsLeadership: (etsLeadershipUserType: EtsLeadershipUserType) => TReturn;
  Agent: (agentUserType: AgentUserType) => TReturn;
  Undetermined: () => TReturn;
};

export const matchEnrollTrackUserType = <TReturn>(
  enrollTrackUserType: ValidEnrollmentTrackingUserType['value'] | InvalidEnrollmentTrackingUserType['value'],
  options: EnrollTrackUserTypeOptions<TReturn>
): TReturn => {
  switch (enrollTrackUserType.key) {
    case 'UndeterminedEnrollmentTrackingUserType':
      return options.Undetermined();
    case 'FileAnalystUserType':
      return options.FileAnalyst(enrollTrackUserType);
    case 'FileManagementUserType':
      return options.FileManagement(enrollTrackUserType);
    case 'EnrollmentTechnologyPartnerUserType':
      return options.EnrollmentTechnologyPartner(enrollTrackUserType);
    case 'EmployerUserType':
      return options.Employer(enrollTrackUserType);
    case 'EtsDataOperationsUserType':
      return options.EtsDataOperations(enrollTrackUserType);
    case 'ManagerUserType':
      return options.Manager(enrollTrackUserType);
    case 'HomeOfficeUserType':
      return options.HomeOffice(enrollTrackUserType);
    case 'EtsEnrollmentOperationsUserType':
      return options.EtsEnrollmentOperations(enrollTrackUserType);
    case 'ClientOnboardingUserType':
      return options.ClientOnboarding(enrollTrackUserType);
    case 'DirectorUserType':
      return options.Director(enrollTrackUserType);
    case 'AdminUserType':
      return options.Admin(enrollTrackUserType);
    case 'BrokerUserType':
      return options.Broker(enrollTrackUserType);
    case 'SalesSupportUserType':
      return options.SalesSupport(enrollTrackUserType);
    case 'SalesDistributionUserType':
      return options.SalesDistribution(enrollTrackUserType);
    case 'EtsLeadershipUserType':
      return options.EtsLeadership(enrollTrackUserType);
    case 'AgentUserType':
      return options.Agent(enrollTrackUserType);
  }
};
